import { api } from "./api"

export const SEND_INVITE = async (formData : any) => {
    const {data} = await api.post("/companies/send/invite", formData)
    return data;
}

export const GET_ALL_INVITES = async () => {
    const {data} = await api.get("/companies/invites")
    return data.invites || [];
}

export const UPDATE_SELF_COMPANY = async (params) => {
    const {data} = await api.patch("/companies/self", params)
    return data;
}
